import React from 'react'
import './Header.css'
// import { auth } from '../firebase'
// import { onAuthStateChanged } from 'firebase/auth'
// import useAuth from '../Hooks/useAuth'
import { Link } from 'react-router-dom'
// import { SignIn, SignOut } from '../utils'

function Header() {
    // const { setAuth } = useAuth() // Auth context state
    // const [userAuth, setUserAuth] = useState([])

    // useEffect(() => {
    //     const unsubscribe = onAuthStateChanged(auth, (user) => {
    //         if (user) {
    //             setUserAuth(user);
    //             setAuth(user);
    //         } else {
    //             setUserAuth(null);
    //             setAuth(null);
    //         }
    //     });

    //     return () => unsubscribe();
    //     // eslint-disable-next-line
    // }, [auth])

    return (
        <header className="header">
            <h2>
                <Link to="/"> Formatr</Link>
            </h2>
            {/* {userAuth !== null ? <>
                <span onClick={SignOut} className='signup_button_header'>Sign out</span>
            </> :
                <span onClick={SignIn} className='signup_button_header'>Start Formatting</span>
            } */}
                <span className='signup_button_header'><Link to="/format" >Start Formatting</Link></span>

        </header>
    )
}

export default Header